import React, { useState, useEffect } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Link,
  List,
  ListItem,
  ListIcon,
  VStack,
  Text,
  HStack,
} from "@chakra-ui/react";
import {
  FiChevronDown,
  FiChevronUp,
  FiMail,
  FiCloud,
  FiExternalLink,
} from "react-icons/fi";
import { FaDropbox, FaInstagram, FaLinkedin, FaAws, FaStripe } from "react-icons/fa";

const TOOL_LINKS = [
  { label: "Mail", href: "https://outlook.office.com/mail/inbox", icon: FiMail },
  { label: "Dropbox", href: "https://www.dropbox.com/home", icon: FaDropbox },
  { label: "NPI Lookup", href: "https://npiregistry.cms.hhs.gov/search", icon: FiExternalLink },
  { label: "Auth0", href: "https://manage.auth0.com/", icon: FiCloud },
  { label: "BoldSign", href: "https://app.boldsign.com/", icon: FiExternalLink },
  { label: "Faxage", href: "https://www.faxage.com/", icon: FiExternalLink },
  { label: "Vonage", href: "https://dashboard.nexmo.com/", icon: FiExternalLink },
  { label: "AWS Console", href: "https://console.aws.amazon.com/", icon: FaAws },
  { label: "CloudWatch", href: "https://console.aws.amazon.com/cloudwatch/", icon: FiCloud },
  { label: "Stripe", href: "https://dashboard.stripe.com/", icon: FaStripe },
];

const SOCIAL_LINKS = [
  { label: "Instagram", href: "https://www.instagram.com/cura.genesis/", icon: FaInstagram },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/curagenesis/", icon: FaLinkedin },
];

const QuickLinksPanel = () => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const storedState = localStorage.getItem("quickLinksExpanded");
    if (storedState === null) {
      localStorage.setItem("quickLinksExpanded", true);
      setIsOpen(true);
    } else {
      setIsOpen(storedState === "true");
    }
  }, []);

  const toggleOpen = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    localStorage.setItem("quickLinksExpanded", newState);
  };

  return (
    <Box mt={6}>
      <HStack justifyContent="space-between" mb={2}>
        <Text fontSize="sm" fontWeight="bold" color="gray.300">
          Quick Links
        </Text>
        <IconButton
          onClick={toggleOpen}
          icon={isOpen ? <FiChevronUp /> : <FiChevronDown />}
          aria-label="Toggle quick links"
          variant="ghost"
          colorScheme="whiteAlpha"
          size="sm"
        />
      </HStack>

      <Collapse in={isOpen} animateOpacity>
        <Box borderTop="1px solid #444" pt={3}>
          <Text fontSize="sm" fontWeight="bold" color="gray.300" mb={2}>Tools</Text>
          <List spacing={2} mb={4}>
            {TOOL_LINKS.map((link) => (
              <ListItem key={link.label}>
                <Link
                  href={link.href}
                  isExternal
                  color="blue.300"
                  _hover={{ color: "white" }}
                >
                  <ListIcon as={link.icon} color="gray.400" />
                  {link.label}
                </Link>
              </ListItem>
            ))}
          </List>

          <Text fontSize="sm" fontWeight="bold" color="gray.300" mb={2}>Socials</Text>
          <List spacing={2}>
            {SOCIAL_LINKS.map((link) => (
              <ListItem key={link.label}>
                <Link
                  href={link.href}
                  isExternal
                  color="blue.300"
                  _hover={{ color: "white" }}
                >
                  <ListIcon as={link.icon} color="gray.400" />
                  {link.label}
                </Link>
              </ListItem>
            ))}
          </List>
        </Box>
      </Collapse>
    </Box>
  );
};

export default QuickLinksPanel;
